import { RESET_REQUEST, RESET_SUCCESS, RESET_FAILURE } from '../../../Constants/actionTypes';

import { API_RESET_BHOM_EVENTS, API_RESET_ITSM_INCIDENTS, API_RESET_FULL_DEMO } from '../../../Constants/apiUrls'


// Helper function to handle errors
const handleErrors = async (response) => {
  if (!response.ok) {
    const errorText = await response.text();
    try {
      const errorJson = JSON.parse(errorText);
      return errorJson.error || 'Unknown Error'; // Return the error message
    } catch (e) {
      return errorText || 'Unknown Error'; // Return the error text if JSON parsing fails
    }
  }
  return null; // No error
};


export const resetRequest = () => ({
  type: RESET_REQUEST,
});

export const resetSuccess = (data) => ({
  type: RESET_SUCCESS,
  payload: data,
});

export const resetFailure = (error) => ({
  type: RESET_FAILURE,
  payload: error,
});

export const resetOnSuccess = () => ({
  type: 'RESET_ON_SUCCESS'
});

export const performReset = (resetName, tenantDetails) => async (dispatch, getState) => {

  console.log(tenantDetails)

  dispatch(resetRequest());

  const payload = {
    bhomUrl: tenantDetails['BHOM URL'],
    itsmUrl: tenantDetails['ITSM REST API URL'],
    key: tenantDetails['Access Key'],
    secretKey: tenantDetails['Access Secret Key'],
    username: tenantDetails['ITSM Username'],
    password: tenantDetails['ITSM Password'],
  };

  let apiUrl;
  switch (resetName) {
    case 'Reset Demo - BHOM (72 Hours)':
      apiUrl = API_RESET_BHOM_EVENTS;
      break;
    case 'Reset Demo - ITSM':
      apiUrl = API_RESET_ITSM_INCIDENTS;
      break;
    case 'Reset Full Demo':
      apiUrl = API_RESET_FULL_DEMO;
      break;
    default:
      throw new Error('Invalid reset name');
  }

  const state = getState();
  const accessToken = state.auth.accessToken; // Adjust this based on your state structure

  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
      body: JSON.stringify(payload),
    });

    const errorMessage = await handleErrors(response); // Check for errors
    if (errorMessage) {
      throw new Error(errorMessage); // Throw an error with the actual error message
    }
    const data = await response.json();
    dispatch(resetSuccess(data));
  } catch (error) {
    let errorMessage;
    if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
      errorMessage = 'Server is currently down. Please try again later.';
    } else {
      errorMessage = error.message;
    }
    dispatch(resetFailure(errorMessage));
  }
};
